import CoursesNav from "../constants/coursesnav";
import { Link } from "react-router-dom";
import { plans } from "../data/plans-data";
import { PlanCard3 } from "./planloader";
import scrollToTop from "./scrolltotop";
import { useEffect, useRef } from "react";

const SubjectPage = ({
  name,
  safe,
  intro,
  description,
  modules,
  bpcolor,
  tris,
  vidd,
  timer,
  pdf,
}) => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (!timer) return;

    const interval = setInterval(() => {
      if (videoRef.current) {
        videoRef.current.currentTime = 0;
        videoRef.current.play();
      }
    }, timer * 1000);
    return () => clearInterval(interval);
  }, [timer]);

  return (
    <>
      <div className="subject-page-container">
        <CoursesNav />

        <img src={tris} alt="tris" className="tris" />

        <div className="content-container">
          <div className="sect1">
            <h1>{name}</h1>
            <p>{intro}</p>
          </div>
          <div className="sect2">
            <h3>Our curriculum</h3>
            <p>{description}</p>
            <div className="content">
              {" "}
              <div className="aligner">
                <h5>Here's a list of our modules</h5>
                <div className="inc-feat-container">
                  {modules.map((modules, index) => (
                    <li className="inc-feature" key={index}>
                      <div
                        className="bulletpoint"
                        style={{ backgroundColor: bpcolor }}
                      />
                      <span>{modules}</span>
                    </li>
                  ))}
                </div>{" "}
                {/*        <a
                  className="btn dlink"
                  href={`/curriculum/${pdf}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View full curriculum
                </a>
           */}{" "}
              </div>
              <video
                key={vidd}
                ref={videoRef}
                alt="ani"
                autoPlay
                loop={!timer}
                muted
                playsInline
                preload="auto"
                disablePictureInPicture
                controlsList="nodownload nofullscreen noremoteplayback"
              >
                <source src={vidd} type="video/mp4" />
              </video>{" "}
              {/*   <a
                className="btn tlink"
                href={`/curriculum/${pdf}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                View full curriculum
              </a>*/}
            </div>
          </div>
          <div className="sect3">
            <h3>Courses Options</h3>
            <div className="opt-scroll">
              <div className="opt">
                {Object.entries(plans)
                  .filter(([key, plan]) => {
                    const [baseId, variant] = key.split("-");
                    if (!plan.subjects.includes(safe)) {
                      return false;
                    }
                    if (baseId === "full11") {
                      return variant === "o2";
                    }

                    return variant === "g2";
                  })
                  .map(([key]) => (
                    <PlanCard3 key={key} planKey={key} subjectSlug={safe} />
                  ))}
              </div>
            </div>

            <Link className="btn" to="/courses" onClick={scrollToTop}>
              View all courses
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default SubjectPage;
